<template>
    <div style="background-color: #fff">
        <div class="mt-3">
            <my-radio :list="orderType.list" v-model="orderType.value"></my-radio>
        </div>
        <el-divider></el-divider>
        <list-pro  @buy="handleBuy"  v-if="orderType.value===1"></list-pro>
        <list-app @buy="handleBuy" v-if="orderType.value===2"></list-app>
        <pay-dialog @close="closeDialog" :order_from="orderType.value" :transfer="pay.transfer"  :show="pay.show" :invoice="pay.invoice" :product="pay.order"></pay-dialog>
    </div>
</template>
<script>
import MyRadio from "@/components/user/buy/invoice/my-radio.vue";
import ListPro from "./list-pro.vue";
import ListApp from "./list-app.vue";
import PayDialog from "@/components/user/buy/pay-dialog.vue";

export default {
    name: "appSms",
    components: {
        MyRadio, ListPro, ListApp, PayDialog
    },
    data: function () {
        return {
            pay: {
                order:{},
                invoice:{},
                transfer:{},
                show: false,
            },
            baseUrl:'/bbs/pay/nopd',
            basePayUrl:'',
            orderType: {
                list: [{title: 'Pro订单', value: 1}, {title: '手机APP订单', value: 2}],
                value: 1
            },
        }
    },
    computed: {},
    methods: {
        closeDialog(){
          this.pay.show=false;
        },
        handleBuy(info) {
            if (this.$store.state.loading) return;
            if (info.type === 'pc-pro') {
                this.$bbs.post(this.baseUrl,{order_from:this.orderType.value,order_id:info.order.order_id}).then(data=>{
                    this.pay.order=data.data.order;
                    if (data.data.company&&!Array.isArray(data.data.company)){
                        this.pay.transfer=data.data.company;
                    }else{
                        this.pay.transfer={};
                    }
                    if (data.data.invoice&&!Array.isArray(data.data.invoice)){
                        this.pay.invoice=data.data.invoice;
                    }else{
                        this.pay.invoice={};
                    }
                    this.pay.show = true;
                });
            }else if (info.type === 'app'){
                this.$bbs.post(this.baseUrl,{order_from:this.orderType.value,order_id:info.order.order_id}).then(data=>{
                    this.pay.order=data.data.order;
                    if (data.data.company&&!Array.isArray(data.data.company)){
                        this.pay.transfer=data.data.company;
                    }else{
                        this.pay.transfer={};
                    }
                    if (data.data.invoice&&!Array.isArray(data.data.invoice)){
                        this.pay.invoice=data.data.invoice;
                    }else{
                        this.pay.invoice={};
                    }
                    this.pay.show = true;
                });
            }
        }
    }
}
</script>
<style lang="less" scoped>
</style>
